/**
 * PCN874 document type codes and descriptions - mirrors Server/Accounting.Infrastructure/Utils/PCN874Constants.cs
 * Use these as the single source of truth for PCN codes in the frontend.
 */
export const DocumentTypeCodes = {
    // Sales Document Types
    REGULAR_SALE: 'S',
    PRIVATE_CUSTOMER_SALE: 'L',
    SELF_INVOICE_SALE: 'M',
    EXPORT_SALE: 'Y',
    PALESTINIAN_CUSTOMER_SALE: 'I',

    // Input Document Types
    REGULAR_INPUT: 'T',
    SELF_INVOICE_INPUT: 'C',
    PETTY_CASH_INPUT: 'K',
    IMPORT_INPUT: 'R',
    PALESTINIAN_SUPPLIER_INPUT: 'P',
    OTHER_DOCUMENT_INPUT: 'H',

    /** C+M pair: sort code 608 causes two PCN lines with types M (income) and C (expense) */
    C_PLUS_M: 'B',
};

/**
 * Sort code IDs per PCN type - matches PCN874Constants.cs SortCodeMapping
 */
export const SortCodeIds = {
    REGULAR_SALE: '110',
    PRIVATE_CUSTOMER_SALE: '140',
    SELF_INVOICE_SALE: '609',
    EXPORT_SALE: '120',
    PALESTINIAN_CUSTOMER_SALE: '360',
    REGULAR_INPUT: '310',
    PETTY_CASH_INPUT: '320',
    IMPORT_INPUT: '350',
    PALESTINIAN_SUPPLIER_INPUT: '370',
    OTHER_DOCUMENT_INPUT: '380',
    SELF_INVOICE_INPUT: '609',
    C_PLUS_M: '608',
};

/**
 * VAT card IDs - matches Constants.cs
 * 1 = מע"מ עיסקאות, 2 = מע"מ תשומות ציוד, 3 = מע"מ תשומות
 */
export const VatCardIds = {
    INCOME: '1',      // מע"מ עיסקאות
    EQUIPMENT: '2',   // מע"מ תשומות ציוד
    EXPENSE: '3',     // מע"מ תשומות
};

/**
 * Document type descriptions - exact text from PCN874Constants.cs DocumentTypeCodes comments
 */
export const DocumentTypeDescriptions = {
    [DocumentTypeCodes.REGULAR_SALE]: 'Regular sale to identified commercial customer',
    [DocumentTypeCodes.PRIVATE_CUSTOMER_SALE]: 'Sale to unidentified (private) customer',
    [DocumentTypeCodes.SELF_INVOICE_SALE]: 'Self invoice sale',
    [DocumentTypeCodes.EXPORT_SALE]: 'Export sale',
    [DocumentTypeCodes.PALESTINIAN_CUSTOMER_SALE]: 'Palestinian Authority customer sale',
    [DocumentTypeCodes.REGULAR_INPUT]: 'Regular input from Israeli supplier',
    [DocumentTypeCodes.SELF_INVOICE_INPUT]: 'Self invoice input',
    [DocumentTypeCodes.PETTY_CASH_INPUT]: 'Petty cash input',
    [DocumentTypeCodes.IMPORT_INPUT]: 'Import input (overseas supplier)',
    [DocumentTypeCodes.PALESTINIAN_SUPPLIER_INPUT]: 'Palestinian Authority supplier input',
    [DocumentTypeCodes.OTHER_DOCUMENT_INPUT]: 'Other document by law (bank, import entry, etc.)',
};

/** Translation keys for each PCN code - use with t(key) */
export const PCNCodeTranslationKeys = {
    [DocumentTypeCodes.REGULAR_SALE]: 'PCNRegularSaleDesc',
    [DocumentTypeCodes.PRIVATE_CUSTOMER_SALE]: 'PCNPrivateCustomerDesc',
    [DocumentTypeCodes.SELF_INVOICE_SALE]: 'PCNReverseChargeDesc',
    [DocumentTypeCodes.EXPORT_SALE]: 'PCNExportDesc',
    [DocumentTypeCodes.PALESTINIAN_CUSTOMER_SALE]: 'PCNPACustomerDesc',
    [DocumentTypeCodes.REGULAR_INPUT]: 'PCNRegularInputDesc',
    [DocumentTypeCodes.SELF_INVOICE_INPUT]: 'PCNSelfInvoiceInputDesc',
    [DocumentTypeCodes.PETTY_CASH_INPUT]: 'PCNPettyCashDesc',
    [DocumentTypeCodes.IMPORT_INPUT]: 'PCNImportInputDesc',
    [DocumentTypeCodes.PALESTINIAN_SUPPLIER_INPUT]: 'PCNPASupplierDesc',
    [DocumentTypeCodes.OTHER_DOCUMENT_INPUT]: 'PCNOtherDocumentDesc',
    [DocumentTypeCodes.C_PLUS_M]: 'PCNCPlusMDesc',
};

/** Translation keys for short display names (e.g. Hebrew labels next to type chips) */
export const PCNCodeNameKeys = {
    [DocumentTypeCodes.REGULAR_SALE]: 'RegularSale',
    [DocumentTypeCodes.PRIVATE_CUSTOMER_SALE]: 'PrivateCustomer',
    [DocumentTypeCodes.SELF_INVOICE_SALE]: 'SelfInvoiceSale',
    [DocumentTypeCodes.EXPORT_SALE]: 'ExportSale',
    [DocumentTypeCodes.PALESTINIAN_CUSTOMER_SALE]: 'PalestinianCustomer',
    [DocumentTypeCodes.REGULAR_INPUT]: 'RegularInput',
    [DocumentTypeCodes.SELF_INVOICE_INPUT]: 'SelfInvoiceInput',
    [DocumentTypeCodes.PETTY_CASH_INPUT]: 'PettyCash',
    [DocumentTypeCodes.IMPORT_INPUT]: 'ImportInput',
    [DocumentTypeCodes.PALESTINIAN_SUPPLIER_INPUT]: 'PalestinianSupplier',
    [DocumentTypeCodes.OTHER_DOCUMENT_INPUT]: 'OtherDocumentByLaw',
    [DocumentTypeCodes.C_PLUS_M]: 'CPlusM',
};
